// extracted by mini-css-extract-plugin
module.exports = {"pagiContainer":"styles_pagiContainer__B0imj"};